import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
export function TermsRestaurantsPage() {
  return <div className="min-h-screen bg-[#0B0B0B] text-white selection:bg-[#006847] selection:text-white" data-id="element-5442">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-[#0B0B0B]/80 backdrop-blur-md border-b border-white/10" data-id="element-5443">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-5444">
          <Link to="/" className="flex items-center gap-2 text-white/60 hover:text-white transition-colors text-sm font-medium" data-id="element-5445">
            <ArrowLeft className="w-4 h-4" data-id="element-5446" />
            Volver
          </Link>
          <div className="font-black text-xl tracking-tight" data-id="element-5447">NOIZA</div>
          <div className="w-20" data-id="element-5448" /> {/* Spacer for centering */}
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-6 py-12 md:py-20" data-id="element-5449">
        <div className="mb-12" data-id="element-5450">
          <div className="w-12 h-12 bg-white/5 rounded-2xl flex items-center justify-center mb-6 border border-white/10" data-id="element-5451">
            <FileText className="w-6 h-6 text-white/80" data-id="element-5452" />
          </div>
          <h1 className="text-3xl md:text-4xl font-black mb-4 tracking-tight" data-id="element-5453">
            Términos y Condiciones para Restaurantes
          </h1>
          <p className="text-white/60 text-lg" data-id="element-5454">
            NOIZA – Plataforma Tecnológica y Marketplace Gastronómico
          </p>
        </div>

        <div className="space-y-12 text-white/80 leading-relaxed" data-id="element-5455">
          <section data-id="element-5456">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5457">
              <span className="text-[#006847]" data-id="element-5458">1.</span>
              INTRODUCCIÓN Y ACEPTACIÓN
            </h2>
            <div className="space-y-4" data-id="element-5459">
              <p data-id="element-5460">
                Los presentes Términos y Condiciones regulan el acceso, uso y
                permanencia del restaurante dentro de la plataforma NOIZA, en
                adelante "la Plataforma".
              </p>
              <p data-id="element-5461">
                Al registrarse, acceder o utilizar cualquier funcionalidad de
                NOIZA, el restaurante declara:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5462">
                <li data-id="element-5463">Haber leído íntegramente este documento</li>
                <li data-id="element-5464">Comprender su contenido en su totalidad</li>
                <li data-id="element-5465">
                  Aceptar voluntaria e irrevocablemente todas sus condiciones
                </li>
              </ul>
              <p data-id="element-5466">
                En caso de no estar de acuerdo con alguno de los puntos
                establecidos, el restaurante deberá abstenerse de utilizar la
                Plataforma.
              </p>
            </div>
          </section>

          <section data-id="element-5467">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5468">
              <span className="text-[#006847]" data-id="element-5469">2.</span>
              NATURALEZA DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-5470">
              <p data-id="element-5471">NOIZA es una solución tecnológica que combina:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5472">
                <li data-id="element-5473">Software como servicio (SaaS)</li>
                <li data-id="element-5474">Marketplace digital gastronómico</li>
                <li data-id="element-5475">Herramientas de gestión operativa para restaurantes</li>
              </ul>
              <p data-id="element-5476">La Plataforma permite a los restaurantes:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5477">
                <li data-id="element-5478">Mostrar su menú digital</li>
                <li data-id="element-5479">Recibir pedidos de clientes</li>
                <li data-id="element-5480">Gestionar su operación interna</li>
                <li data-id="element-5481">
                  Facilitar la comunicación directa con el cliente
                  (principalmente vía WhatsApp)
                </li>
              </ul>
              <p className="font-medium text-white" data-id="element-5482">
                NOIZA actúa únicamente como un facilitador tecnológico.
              </p>
            </div>
          </section>

          <section data-id="element-5483">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5484">
              <span className="text-[#006847]" data-id="element-5485">3.</span>
              DECLARACIÓN EXPRESA DE NO INTERMEDIACIÓN
            </h2>
            <div className="space-y-4" data-id="element-5486">
              <p data-id="element-5487">El restaurante reconoce expresamente que NOIZA:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5488">
                <li data-id="element-5489">No es proveedor de alimentos</li>
                <li data-id="element-5490">No participa en la preparación de productos</li>
                <li data-id="element-5491">No manipula alimentos en ningún momento</li>
                <li data-id="element-5492">No realiza entregas ni logística</li>
                <li data-id="element-5493">No procesa pagos en nombre del restaurante</li>
                <li data-id="element-5494">No actúa como representante comercial del restaurante</li>
              </ul>
              <p data-id="element-5495">
                La Plataforma se limita a proporcionar herramientas digitales
                para facilitar la interacción entre el restaurante y el cliente
                final.
              </p>
            </div>
          </section>

          <section data-id="element-5496">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5497">
              <span className="text-[#006847]" data-id="element-5498">4.</span>
              INDEPENDENCIA DEL RESTAURANTE
            </h2>
            <div className="space-y-4" data-id="element-5499">
              <p data-id="element-5500">
                Cada restaurante que utiliza NOIZA opera como una entidad
                completamente independiente.
              </p>
              <p data-id="element-5501">Esto implica que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5502">
                <li data-id="element-5503">El restaurante es el único responsable de su operación</li>
                <li data-id="element-5504">
                  No existe relación laboral, societaria o de representación con
                  NOIZA
                </li>
                <li data-id="element-5505">
                  NOIZA no ejerce control sobre las decisiones del restaurante
                </li>
              </ul>
              <p data-id="element-5506">El restaurante mantiene total autonomía en:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5507">
                <li data-id="element-5508">Precios</li>
                <li data-id="element-5509">Menú</li>
                <li data-id="element-5510">Horarios</li>
                <li data-id="element-5511">Métodos de pago</li>
                <li data-id="element-5512">Procesos internos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-5513">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5514">
              <span className="text-[#006847]" data-id="element-5515">5.</span>
              EXCLUSIÓN TOTAL DE RESPONSABILIDAD
            </h2>

            <div className="space-y-8" data-id="element-5516">
              <div data-id="element-5517">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5518">
                  5.1. Alcance general
                </h3>
                <p data-id="element-5519">
                  El restaurante acepta que NOIZA queda exento de cualquier tipo
                  de responsabilidad, directa o indirecta, derivada de la
                  operación del restaurante.
                </p>
              </div>

              <div data-id="element-5520">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5521">
                  5.2. Alimentos y calidad del servicio
                </h3>
                <p className="mb-2" data-id="element-5522">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-5523">
                  <li data-id="element-5524">Calidad de los alimentos</li>
                  <li data-id="element-5525">Estado, frescura o preparación</li>
                  <li data-id="element-5526">Ingredientes utilizados</li>
                  <li data-id="element-5527">Contaminación cruzada</li>
                  <li data-id="element-5528">Problemas de higiene o salubridad</li>
                  <li data-id="element-5529">Reacciones alérgicas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-5530">
                  Toda responsabilidad recae exclusivamente en el restaurante.
                </p>
              </div>

              <div data-id="element-5531">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5532">
                  5.3. Entregas y logística
                </h3>
                <p className="mb-2" data-id="element-5533">
                  NOIZA no participa ni interviene en la entrega de pedidos. Por
                  lo tanto, NOIZA no será responsable por:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5534">
                  <li data-id="element-5535">Retrasos en la entrega</li>
                  <li data-id="element-5536">Pérdida de pedidos</li>
                  <li data-id="element-5537">Entregas incompletas</li>
                  <li data-id="element-5538">Errores en dirección</li>
                  <li data-id="element-5539">Conducta de repartidores</li>
                  <li data-id="element-5540">Daños durante el transporte</li>
                </ul>
              </div>

              <div data-id="element-5541">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5542">
                  5.4. Pagos
                </h3>
                <p className="mb-2" data-id="element-5543">
                  NOIZA no procesa ni administra pagos. El restaurante es el
                  único responsable de:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-4" data-id="element-5544">
                  <li data-id="element-5545">Recepción de pagos</li>
                  <li data-id="element-5546">Validación de transferencias (incluyendo SINPE)</li>
                  <li data-id="element-5547">Manejo de efectivo</li>
                  <li data-id="element-5548">Confirmación de pagos</li>
                  <li data-id="element-5549">Prevención de fraudes</li>
                </ul>
                <p className="mb-2" data-id="element-5550">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5551">
                  <li data-id="element-5552">Pagos no recibidos</li>
                  <li data-id="element-5553">Comprobantes falsos</li>
                  <li data-id="element-5554">Errores en montos</li>
                  <li data-id="element-5555">Estafas o fraudes de terceros</li>
                </ul>
              </div>

              <div data-id="element-5556">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-5557">
                  5.5. Relación con clientes
                </h3>
                <p className="mb-2" data-id="element-5558">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-5559">
                  <li data-id="element-5560">Reclamos de clientes</li>
                  <li data-id="element-5561">Reembolsos</li>
                  <li data-id="element-5562">Cancelaciones</li>
                  <li data-id="element-5563">Disputas</li>
                  <li data-id="element-5564">Opiniones o reseñas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-5565">
                  Toda relación comercial se da directamente entre el
                  restaurante y el cliente.
                </p>
              </div>
            </div>
          </section>

          <section data-id="element-5566">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5567">
              <span className="text-[#006847]" data-id="element-5568">6.</span>
              USO DE LA PLATAFORMA
            </h2>
            <div className="space-y-4" data-id="element-5569">
              <p data-id="element-5570">El restaurante se compromete a utilizar NOIZA de forma:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5571">
                <li data-id="element-5572">Responsable</li>
                <li data-id="element-5573">Legal</li>
                <li data-id="element-5574">Transparente</li>
              </ul>
              <p className="mt-4" data-id="element-5575">Queda prohibido:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5576">
                <li data-id="element-5577">Publicar información falsa</li>
                <li data-id="element-5578">Manipular precios de forma engañosa</li>
                <li data-id="element-5579">Simular disponibilidad inexistente</li>
                <li data-id="element-5580">Utilizar la plataforma con fines fraudulentos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-5581">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5582">
              <span className="text-[#006847]" data-id="element-5583">7.</span>
              PROPIEDAD DEL MENÚ DIGITAL
            </h2>
            <div className="space-y-4" data-id="element-5584">
              <p data-id="element-5585">El menú digital creado dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5586">
                <li data-id="element-5587">Pertenece al restaurante en términos de contenido</li>
                <li data-id="element-5588">
                  Puede ser utilizado por el restaurante fuera del marketplace
                </li>
              </ul>
              <p className="mt-4 font-medium text-white" data-id="element-5589">Condiciones:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-5590">
                <li data-id="element-5591">
                  Si el restaurante mantiene una suscripción activa, el sistema
                  opera normalmente
                </li>
                <li data-id="element-5592">
                  Si no mantiene suscripción:
                  <ul className="list-circle pl-6 mt-2 space-y-1" data-id="element-5593">
                    <li data-id="element-5594">
                      Podrá seguir utilizando el sistema únicamente si cubre
                      costos asociados (hosting, dominio, etc.)
                    </li>
                    <li data-id="element-5595">NOIZA podrá limitar funcionalidades</li>
                  </ul>
                </li>
              </ul>
            </div>
          </section>

          <section data-id="element-5596">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5597">
              <span className="text-[#006847]" data-id="element-5598">8.</span>
              SISTEMA SaaS
            </h2>
            <div className="space-y-4" data-id="element-5599">
              <p data-id="element-5600">NOIZA proporciona un sistema tecnológico que incluye:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5601">
                <li data-id="element-5602">Menú digital</li>
                <li data-id="element-5603">Gestión de pedidos</li>
                <li data-id="element-5604">Herramientas operativas</li>
              </ul>
              <div className="grid sm:grid-cols-2 gap-6 mt-6" data-id="element-5605">
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-5606">
                  <p className="font-medium text-white mb-2" data-id="element-5607">
                    El restaurante recibe:
                  </p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5608">
                    <li data-id="element-5609">Derecho de uso del sistema</li>
                  </ul>
                </div>
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-5610">
                  <p className="font-medium text-white mb-2" data-id="element-5611">NO recibe:</p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5612">
                    <li data-id="element-5613">Propiedad del software</li>
                    <li data-id="element-5614">Acceso al código fuente</li>
                  </ul>
                </div>
              </div>
              <p className="font-medium text-white mt-4" data-id="element-5615">
                NOIZA mantiene todos los derechos sobre la tecnología
                desarrollada.
              </p>
            </div>
          </section>

          <section data-id="element-5616">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5617">
              <span className="text-[#006847]" data-id="element-5618">9.</span>
              DISPONIBILIDAD DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-5619">
              <p data-id="element-5620">NOIZA no garantiza:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5621">
                <li data-id="element-5622">Disponibilidad continua</li>
                <li data-id="element-5623">Funcionamiento sin interrupciones</li>
                <li data-id="element-5624">Ausencia total de errores</li>
              </ul>
              <p className="mt-4" data-id="element-5625">Pueden ocurrir:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5626">
                <li data-id="element-5627">Fallas técnicas</li>
                <li data-id="element-5628">Actualizaciones</li>
                <li data-id="element-5629">Mantenimientos</li>
              </ul>
              <p className="font-medium text-white mt-2" data-id="element-5630">
                NOIZA no será responsable por pérdidas derivadas de estos
                eventos.
              </p>
            </div>
          </section>

          <section data-id="element-5631">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5632">
              <span className="text-[#006847]" data-id="element-5633">10.</span>
              VISIBILIDAD EN EL MARKETPLACE
            </h2>
            <div className="space-y-4" data-id="element-5634">
              <p data-id="element-5635">El restaurante acepta que su visibilidad dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5636">
                <li data-id="element-5637">No está garantizada permanentemente</li>
                <li data-id="element-5638">Puede variar según criterios internos</li>
              </ul>
              <p className="mt-4" data-id="element-5639">NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5640">
                <li data-id="element-5641">Destacar o no restaurantes</li>
                <li data-id="element-5642">Modificar posiciones</li>
                <li data-id="element-5643">Aplicar filtros o algoritmos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-5644">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5645">
              <span className="text-[#006847]" data-id="element-5646">11.</span>
              PAGOS Y CONDICIONES ECONÓMICAS
            </h2>
            <div className="space-y-4" data-id="element-5647">
              <p data-id="element-5648">El restaurante se compromete a:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5649">
                <li data-id="element-5650">Cumplir con los pagos acordados</li>
                <li data-id="element-5651">Mantener su cuenta al día</li>
              </ul>
              <p className="mt-4" data-id="element-5652">En caso de incumplimiento, NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5653">
                <li data-id="element-5654">Suspender el servicio</li>
                <li data-id="element-5655">Limitar funcionalidades</li>
                <li data-id="element-5656">Retirar visibilidad</li>
              </ul>
            </div>
          </section>

          <section data-id="element-5657">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5658">
              <span className="text-[#006847]" data-id="element-5659">12.</span>
              TERMINACIÓN
            </h2>
            <div className="space-y-4" data-id="element-5660">
              <p data-id="element-5661">NOIZA podrá suspender o terminar el acceso en caso de:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5662">
                <li data-id="element-5663">Incumplimiento de términos</li>
                <li data-id="element-5664">Uso indebido</li>
                <li data-id="element-5665">Conductas que afecten la plataforma</li>
              </ul>
              <p className="mt-2" data-id="element-5666">
                El restaurante podrá dejar de usar el servicio en cualquier
                momento.
              </p>
            </div>
          </section>

          <section data-id="element-5667">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5668">
              <span className="text-[#006847]" data-id="element-5669">13.</span>
              MODIFICACIONES
            </h2>
            <div className="space-y-4" data-id="element-5670">
              <p data-id="element-5671">NOIZA podrá modificar estos términos en cualquier momento.</p>
              <p data-id="element-5672">El uso continuo implica aceptación automática de cambios.</p>
            </div>
          </section>

          <section data-id="element-5673">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5674">
              <span className="text-[#006847]" data-id="element-5675">14.</span>
              LIMITACIÓN DE RESPONSABILIDAD
            </h2>
            <div className="space-y-4" data-id="element-5676">
              <p data-id="element-5677">En ningún caso NOIZA será responsable por:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-5678">
                <li data-id="element-5679">Pérdidas económicas</li>
                <li data-id="element-5680">Daños indirectos</li>
                <li data-id="element-5681">Lucro cesante</li>
                <li data-id="element-5682">Daños reputacionales</li>
              </ul>
            </div>
          </section>

          <section data-id="element-5683">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5684">
              <span className="text-[#006847]" data-id="element-5685">15.</span>
              LEGISLACIÓN APLICABLE
            </h2>
            <div className="space-y-4" data-id="element-5686">
              <p data-id="element-5687">
                Estos términos se regirán por la legislación aplicable en Costa
                Rica.
              </p>
            </div>
          </section>

          <section className="bg-white/5 p-6 rounded-2xl border border-white/10 mt-12" data-id="element-5688">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-5689">
              <span className="text-[#006847]" data-id="element-5690">16.</span>
              ACEPTACIÓN FINAL
            </h2>
            <div className="space-y-4" data-id="element-5691">
              <p className="font-medium" data-id="element-5692">El restaurante declara que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/80" data-id="element-5693">
                <li data-id="element-5694">Ha leído este documento completo</li>
                <li data-id="element-5695">Comprende su alcance</li>
                <li data-id="element-5696">Acepta todas sus condiciones</li>
              </ul>
            </div>
          </section>
        </div>
      </main>
    </div>;
}